module.exports = __webpack_public_path__ + "img/logo.11486af2.svg";